module.exports = __webpack_public_path__ + "static/img/banner-prompt@3x.66dbe28.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/banner-prompt@3x.png
// module id = 58
// module chunks = 46